export default "__VITE_ASSET__45KANZIe__"